import React, { useState, useEffect } from 'react';
import * as S from './FareOptions.styles';

const FareOption = ({
  fareOption,
  travelType,
  journeyType,
  passengers,
  flightClass,
  arrival,
  departure,
  fareType,
  fareTypeChangeHandler
}) => {
  if (!fareOption || Object.keys(fareOption).length === 0) {
    return null;
  }

  const [diableFareOption, setDisableFareOption] = useState(false);
  const [errorType, setErrorType] = useState('');

  // const {
  //   bottom_sheet,
  //   details,
  //   faretype,
  //   identifier,
  //   isnew
  // } = fareOption;

  const { details, ft = '', isnew = false, identifier } = fareOption || {};
  const { icon, text, subtext, bottom_sheet = null } = details || {};
  const { heading = '', content = '', bg_clr = [] } = bottom_sheet || {};

  return (
    <S.ClassWrap>
      <S.Checkbox
        type="checkbox"
        name="flt-class-group1"
        value={text}
        onChange={() => {}}
        onClick={() => fareTypeChangeHandler(identifier, fareOption)}
        checked={fareType === identifier}
        disabled={diableFareOption}
      />
      <S.CheckboxLabel
        id="special_fare_checkbox"
        htmlFor="radio-1"
        disabled={diableFareOption}
      ></S.CheckboxLabel>
      <S.LabelText className="txtCap">
        <span id="special_fare_text" dangerouslySetInnerHTML={{ __html: text }}></span>
        {isnew ? <span className="newTag">NEW</span> : null}
      </S.LabelText>
      {(bottom_sheet && (
        <S.FareTypeTooltip bgColor={bg_clr} tipWidth="295px" className="fareTooltip">
          <div className="dF">
            <span>
              {heading && (
                <p className="flex1 marginL10" dangerouslySetInnerHTML={{ __html: heading }}></p>
              )}
              {content && (
                <p className="flex1 marginL10" dangerouslySetInnerHTML={{ __html: content }}></p>
              )}
            </span>
          </div>
        </S.FareTypeTooltip>
      )) ||
        null}
      {/* {hovertype === 'details' || diableFareOption ? (
        <S.FareTypeTooltip tipWidth="295px" className="fareTooltip">
          <div className="dF">
            {icon && <img src={icon} width="25px" height="25px" alt="fare_tooltip" />}
            <span>
              {text && (
                <p className="flex1 marginL10" dangerouslySetInnerHTML={{ __html: text }}></p>
              )}
              {subtext && (
                <p className="flex1 marginL10" dangerouslySetInnerHTML={{ __html: subtext }}></p>
              )}
            </span>
          </div>
        </S.FareTypeTooltip>
      ) : hovertype === 'bottom_sheet' ? (
        bottom_sheet && (
          <S.FareTypeTooltip tipWidth="550px" className="fareTooltip extraSeatTip">
            {bottom_sheet?.heading && (
              <p className="blueCnt f500 marginB10 font18">{bottom_sheet.heading}</p>
            )}
            {bottom_sheet?.sub_heading && (
              <p className=" f500 marginB20 font18 greyDr">{bottom_sheet.sub_heading}</p>
            )}
            {bottom_sheet?.image_url && (
              <div className="dF justifyBetween marginB30">
                <img
                  src={bottom_sheet.image_url}
                  width="450px"
                  height="160px"
                  alt="fare_bottom_sheet"
                />
              </div>
            )}
            <ul className="f500 extraSeatDesc marginB20">
              {(bottom_sheet?.details || []).map(detail => (
                <li>{detail}</li>
              ))}
            </ul>
            <div>
              {(bottom_sheet?.tnc || []).map(terms => (
                <p className="dF">
                  <span className="red marginR5 f500">*</span>
                  <span className="flex1">
                    <span className="f500">{`${terms.title} - `}</span>
                    <span className="f500 greyCnt">{terms.value}</span>
                  </span>
                </p>
              ))}
            </div>
          </S.FareTypeTooltip>
        )
      ) : null} */}
    </S.ClassWrap>
  );
};

const FareOptionsUI = ({
  fareOptionsInfo,
  travelType,
  journeyType,
  passengers,
  flightClass,
  arrival,
  departure,
  handleFareOptionSelection,
  selectedFareIdentifier
}) => {
  if (!fareOptionsInfo || !fareOptionsInfo?.fares?.length) {
    return null;
  }
  const { fares = [] } = fareOptionsInfo;

  return (
    <S.Wrapper>
      <S.SearchLabelStyle>FARE TYPE</S.SearchLabelStyle>
      <div>
        <S.RadioWrapper>
          {fares.map((fareOption, index) => (
            <FareOption
              key={index}
              fareOption={fareOption}
              travelType={travelType}
              journeyType={journeyType}
              passengers={passengers}
              flightClass={flightClass}
              arrival={arrival}
              departure={departure}
              fareType={selectedFareIdentifier}
              fareTypeChangeHandler={handleFareOptionSelection}
            />
          ))}
        </S.RadioWrapper>
      </div>
    </S.Wrapper>
  );
};

export default FareOptionsUI;
